import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@mui/material";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";

export const LookingSolution = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const history = useHistory();
  const theme = useTheme();

  const handleRedirection = () => {
    const path =
      currentLanguage === "en" ? "/enroll" : `/${currentLanguage}/enroll`;
    history.push(path);
  };

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: "#FFF8F1",
        textAlign: "center",
        py: 8,
        my: 8,
        mx: { xs: 2, md: "15%" },
        position: "relative",
      }}
    >
      <Typography
        variant="h4"
        fontWeight={700}
        color={theme.palette.secondary.main}
        gutterBottom
      >
        {t("NurseryPage.LookingSolution.title")}
      </Typography>

      <Typography
        variant="body1"
        textAlign="center"
        color="text.primary"
        maxWidth={800}
        mx="auto"
        mb={2}
      >
        {t("NurseryPage.LookingSolution.text")}
      </Typography>

      <OrangeHighlightButton onClick={handleRedirection} sx={{ mt: 4 }}>
        {t("NurseryPage.LookingSolution.buttonText")}
      </OrangeHighlightButton>
    </Box>
  );
};
